<template>
    <div v-if="hotspot">
        <div class="form-group">
            <div class="col-sm-12">
                <label for="usuario" class="control-label">USUÁRIO</label>
                <input id="usuario" disabled type="text" v-model="hotspot.usuario" class="form-control" >
            </div>
        </div>
        <div class="panel panel-info">
            <div class="panel-heading">
                <i class="fa fa-table" aria-hidden="true"></i> SENHAS DO CLIENTE PARA HOTSPOT
            </div>
            <div class="panel-body">

                <table id="mytable" class="table table-bordred table-striped">

                    <thead>
                        <tr>
                            <th style="text-align: center;">SENHA</th>
                            <th style="text-align: center;">MAC</th>
                            <th style="text-align: center;">AÇÕES</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="r in hotspot.senhas" v-bind:key="r._id">
                            <td style="text-align: center">{{ String(r.senha).toLowerCase() }}</td>
                            <td style="text-align: center">{{ r.mac }}</td>
                            <td style="text-align: center; width: 120px">
                                <a @click="remove(r.senha)" v-if="user.level <= 1" class="btn btn-danger btn-xs">
                                    APAGAR <i class="fa fa-remove" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
    </div>
</template>
<script>
import { Contratos } from "../../class/contratos";

export default {
    props: {
        hotspot: {
            default: null
        },
        id: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        remove(senha) {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "Hotspot",
                    confirmButtonText: "Excluir",
                    text: "Posso excluir a senha?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Contratos.removeSenhaHotspot(this.id, senha)
                                .then(() => {
                                    this.$emit("reload");
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
